


import { useTheme, Divider, Grid, Box, Button, Typography } from "@mui/material";
import { useState, useMemo, useEffect } from "react";

import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { tokens } from "../../../theme/theme";
import useGetSONumberListForReelTransfer from "../../../hooks/useGetSONumberListForReelTransfer";
import useGetSONumberWiseLineItemListForReelTransfer from "../../../hooks/useGetSONumberWiseLineItemsForReelTransfer";
import Header from "../../../Layout/Header";
import useGetChildRollListBySONumber from "../../../hooks/useGetChildRollListBySONumber";
import TransferSalesOrderSection from "./TransferSalesOrderSection";
import FastForwardOutlinedIcon from '@mui/icons-material/FastForwardOutlined';
import CallAlertBar from "../../../Layout/Alertbar";
import useReelTransferCRUD from "../../../hooks/useReelTransferCRUD";
import TransferReelListDetail from "./TransferList";
import useUserPermissions from "../../../components/user-permission/UserPermission";
import { hasPermission } from "../../../components/user-permission/AuthorizationParameter";

const TransferReelBasedOnSONumber = ({ handleBackWinderMachineEntry }) => {


    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const userPermissions = useUserPermissions();
    // message are 
    const [msgOpen, setMsgOpen] = useState(false);
    const [severityValue, setSeverityvalue] = useState('info');
    const [messageValue, setMessageValue] = useState('Welcome to Paper Roll Booking! ');
    const [alertTitleValue, setAlertTitleValue] = useState('');
    const [checkStatus, setCheckStatus] = useState(false);

    // call message
    const CallMessage = (serverityval, msg, title) => {
        setSeverityvalue(serverityval);
        setMessageValue(msg);
        setAlertTitleValue(title);
        setMsgOpen(true);
    };

    // hooks
    const transferForByHook = useGetSONumberListForReelTransfer(0);
    const transferToByHook = useGetSONumberListForReelTransfer(0);

    const lineItemListForByHook = useGetSONumberWiseLineItemListForReelTransfer();
    const lineItemListToByHook = useGetSONumberWiseLineItemListForReelTransfer();

    const childRollListForByHook = useGetChildRollListBySONumber();
    const childRollListToByHook = useGetChildRollListBySONumber();

    const { processIndent } = useReelTransferCRUD(CallMessage);

    // sub page call
    const [viewTransferedReel, setViewTransferedReel] = useState(false);

    // table
    const [selectedRows, setSelectedRows] = useState([]);
    const [selectedStatus, setSelectedStatus] = useState('All');
    const [margins, setMargins] = useState({ margin: 1, marginTop: 0 });

    const isSelected = (rowId) => selectedRows.indexOf(rowId) !== -1;


    const callback = () => {
        handleBackWinderMachineEntry();
    };

    const handleEdit = (line_no, mode, width, length, quality, gsm) => {
        const hooksMap = {
            For: {
                hook: childRollListForByHook,
                salesOrder: transferForByHook.selectedSalesOrderNumber,
                hook1: transferForByHook,
            },
            To: {
                hook: childRollListToByHook,
                salesOrder: transferToByHook.selectedSalesOrderNumber,
                hook1: transferToByHook,
            },
        };

        const selected = hooksMap[mode];
        selected?.hook.loadChildRollBasedOnSoNumber(selected.salesOrder, line_no);
        selected?.hook1.loadSalesOrderNumberByID(selected.salesOrder, line_no, width, length, quality, gsm);

        // refresh to detail
        if (mode === 'For') {
            transferToByHook.refreshSelectionDetail();
            transferToByHook.fetchTransferOrderToList(quality, gsm);
            lineItemListToByHook.clearLineitems();
            childRollListToByHook.clearChildRollList();
        }
        setCheckStatus(true);
    };

    const [filters, setFilters] = useState({
        product_code: '',
        item_code: '',
        gsm: '',
        size: '',
        grain: '',
        grade: '',
        store_code: '',
        customer_name: '',
        supplier_name: '',
        indent_no: '',
        product_type: '',
    });

    const filteredData = useMemo(() => {
        return childRollListForByHook.childRollList.filter((row) => {
            if (selectedStatus !== 'All' && row.status !== selectedStatus) return false;

            return Object.entries(filters).every(([key, value]) => {
                return value === '' || String(row[key] ?? '').toLowerCase().includes(value.toLowerCase());
            });
        });
    }, [childRollListForByHook.childRollList, filters, selectedStatus]);


    const handleSelectAllClick = (event) => {
        const allSelectableIds = filteredData
            .map((row) => row.id_product);

        setSelectedRows(event.target.checked ? allSelectableIds : []);
    };


    const handleRowCheckboxClick = (event, rowId) => {
        setSelectedRows((prevSelected) =>
            prevSelected.includes(rowId)
                ? prevSelected.filter((id) => id !== rowId)
                : [...prevSelected, rowId]
        );
    };


    // calculate reel weight common function 
    const calculateTotalWeight = (list, filterFn = () => true) =>
        list
            .filter(filterFn)
            .reduce((sum, row) => sum + (parseFloat(row.weight) || 0), 0)
            .toFixed(1);
    const totalSelectedWeight = calculateTotalWeight(filteredData, (s) => selectedRows.includes(s.id_product));
    const totalSelectedWeightForTo = calculateTotalWeight(childRollListToByHook.childRollList);

    // selected reel count
    const selectedReelCount = childRollListForByHook.childRollList.filter((p) => selectedRows.includes(p.id_product));

    // call transfer process
    const handleSave = async () => {



        let errorMessage = "";
        let isvalid = true;

        // call validation
        const selectedProducts = childRollListForByHook.childRollList.filter((p) => selectedRows.includes(p.id_product));
        if (selectedProducts.length === 0) {
            errorMessage = "Please select at least one child roll for transfer.";
            CallMessage('warning', errorMessage, 'Warning');
            return;
        }

        if (transferToByHook.selectedSalesOrderNumber.so_number === undefined || transferToByHook.selectedSalesOrderNumber.so_number === '') {
            errorMessage = "Please select at transfer to so number.";
            return;
        }
        if (transferToByHook.selectedWidth === 0) {
            errorMessage = `Please select transfer to line item.`;
            CallMessage('warning', errorMessage, 'Warning');
            return;
        }

        isvalid = handleValidation();

        if (isvalid) {
            const payload = {
                p_companyid: localStorage.getItem('companyid') || 0,
                p_plantid: 1,
                p_so_number: transferToByHook.selectedSalesOrderNumber.so_number,
                p_line_no: transferToByHook.selectedLineNumber,
                p_selected_childroll: selectedProducts,
                p_user_name: localStorage.getItem('userID') || '',
            };

            await processIndent(payload);
            await handleEdit(transferToByHook.selectedLineNumber, 'To', transferToByHook.selectedWidth, transferToByHook.selectedLength);
            await handleEdit(transferForByHook.selectedLineNumber, 'For', transferForByHook.selectedWidth, transferForByHook.selectedLength);
        }
    }

    useEffect(() => {
        if (msgOpen) {
            setMargins({ margin: 0, marginTop: 1 });
        } else {
            setMargins({ margin: 1, marginTop: 0 });
        }
    }, [msgOpen]);

    // validation 
    const handleValidation = () => {

        const selectedProducts = childRollListForByHook.childRollList.filter((p) => selectedRows.includes(p.id_product));
        let message = '';

        if (transferToByHook.selectedLength === 0) {
            // Reel logic
            for (let i = 0; i < selectedProducts.length; i++) {
                const product = selectedProducts[i];
                const [width, length] = product.size.split('X').map(val => parseFloat(val.trim()));
                const masterReelWidth = parseFloat(product.product_type);
                const selectedWidth = parseFloat(transferToByHook.selectedWidth);



                if (selectedWidth !== width) {
                    message = `Produced reel is assigned to a reel order, so the width must match. Selected width: ${selectedWidth}, reel width: ${width}`;
                    break;
                } else if (selectedWidth !== masterReelWidth) {
                    message = `Selected master width (${masterReelWidth}) does not match the transfer size: ${selectedWidth}`;
                    break;
                }
            }
        } else {
            // Sheet logic
            for (let i = 0; i < selectedProducts.length; i++) {
                const product = selectedProducts[i];
                const bWidth = transferToByHook.selectedWidth;
                const bLength = transferToByHook.selectedLength;
                const [aWidth, aLength] = product.size.split('X').map(val => parseFloat(val.trim()));

                // Check: Either (B ≤ A) or (rotated B ≤ A)
                const isValid = (bWidth <= aWidth || bLength <= aLength) ||
                    (bWidth <= aLength || bLength <= aWidth);

                if (!isValid) {
                    message = `Sheet size (${bWidth} X ${bLength}) must have at least one side less than or equal to A order size (${aWidth} X ${aLength})`;
                    break;
                }
            }
        }

        if (message) {
            CallMessage('warning', message, 'Warning');
            return false;
        }
        return true; // If no errors
    };

    const handleListofTranferReel = () => {
        setViewTransferedReel(true);
    };

    const handleListofTranferReelCallBack = () => {
        setViewTransferedReel(false);
    };

    useEffect(() => {
        if (checkStatus) {
            if (childRollListForByHook?.childRollList.length === 0) {
                alert(childRollListForByHook.emptyReelMessage);
            }
            setCheckStatus(false);
        }

    }, [checkStatus]);






    return (

        <>
            {!viewTransferedReel && (<>
                <Header title="Transfer Produced Reels to Another Sales Order" subtitle="" callback={callback} />
                <Divider />
                <Box padding={1}>
                    <Button variant="contained" color="secondary" size="small" onClick={() => handleListofTranferReel()}>List of transfered reels</Button>
                </Box>
                <Divider sx={{ marginBottom: margins.margin }} />

                <CallAlertBar parentRollMsgOpen={msgOpen} setParentRollMsgOpen={setMsgOpen} parentRollSeverityvalue={severityValue}
                    setParentRollSeverityvalue={setSeverityvalue} parentRollAlertTitleValue={alertTitleValue}
                    setParentRollAlertTitleValue={setAlertTitleValue} parentRollMessageValue={messageValue} setParentRollMessageValue={setMessageValue} />
                <Grid container spacing={1} marginTop={margins.marginTop}>
                    {/* From Sales Order */}
                    <Grid item lg={6} xl={6}>

                        <TransferSalesOrderSection
                            title="Transfer From Sales Order"
                            hook={transferForByHook}
                            lineItemHook={lineItemListForByHook}
                            childRollHook={childRollListForByHook}
                            onLineClick={(lineNo, width, length, quality, gsm) => handleEdit(lineNo, "For", width, length, quality, gsm)}
                            showCheckbox={true}
                            selectedRows={selectedRows}
                            onRowCheckboxClick={handleRowCheckboxClick}
                            onSelectAllClick={handleSelectAllClick}
                            isSelected={isSelected}
                            totalSelectedWeight={totalSelectedWeight}
                            colors={colors} // ✅ ADD THIS
                        />

                    </Grid>
                    {/* <Typography>{childRollListForByHook?.emptyReelMessage}</Typography> */}

                    {/* To Sales Order */}
                    <Grid item lg={6} xl={6}>
                        {selectedReelCount.length > 0 && (
                            <TransferSalesOrderSection
                                title="Transfer To Sales Order"
                                hook={transferToByHook}
                                lineItemHook={lineItemListToByHook}
                                childRollHook={childRollListToByHook}
                                onLineClick={(lineNo, width, length, quality, gsm) => handleEdit(lineNo, "To", width, length, quality, gsm)}
                                showCheckbox={false}
                                totalSelectedWeight={totalSelectedWeightForTo}
                                colors={colors} // ✅ ADD THIS
                            />
                        )}
                    </Grid>

                </Grid>
                <Divider sx={{ marginBottom: 2 }} />



                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    {selectedReelCount.length > 0 && (


                        <Box sx={{ display: "flex", justifyContent: "flex-end", marginRight: "10px" }}>

                            {hasPermission(userPermissions, "Reel Transfer", "Update") && (
                                <Button startIcon={<FastForwardOutlinedIcon />} onClick={() => handleSave()} sx={{ mr: '10px' }} variant="contained" color="secondary" size="small">Transfer Reel</Button>

                            )}
                        </Box>



                    )}
                </Grid>

            </>) || (<>
                <TransferReelListDetail callback={handleListofTranferReelCallBack} />
            </>)}
        </>


    );
};
export default TransferReelBasedOnSONumber;